/**
 * Fabpad FAQ page — tab switching
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-fabpad-faq]');
  if (!root) return;

  var tabs = root.querySelectorAll('[data-faq-tab]');
  var panels = root.querySelectorAll('[data-faq-panel]');
  var tabsRow = root.querySelector('[data-faq-tabs]');
  var tabsWrap = root.querySelector('[data-faq-tabs-wrap]');
  var nextBtn = root.querySelector('[data-faq-tabs-next]');
  var prevBtn = root.querySelector('[data-faq-tabs-prev]');

  function isMobileTabs() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function updateTabArrows() {
    if (!tabsRow || !tabsWrap) return;
    if (!isMobileTabs()) {
      if (nextBtn) nextBtn.hidden = true;
      if (prevBtn) prevBtn.hidden = true;
      tabsWrap.classList.remove('is-end');
      return;
    }
    var maxScroll = tabsRow.scrollWidth - tabsRow.clientWidth;
    var atStart = tabsRow.scrollLeft <= 8;
    var atEnd = tabsRow.scrollLeft >= maxScroll - 8;
    if (prevBtn) prevBtn.hidden = atStart;
    if (nextBtn) nextBtn.hidden = atEnd || maxScroll <= 8;
    tabsWrap.classList.toggle('is-end', atEnd || maxScroll <= 8);
    tabsWrap.classList.toggle('is-start', atStart);
  }

  function scrollTabs(direction) {
    if (!tabsRow) return;
    var amount = Math.max(140, Math.round(tabsRow.clientWidth * 0.7));
    tabsRow.scrollBy({ left: direction * amount, behavior: 'smooth' });
  }

  function activateTab(id) {
    tabs.forEach(function (tab) {
      var isActive = tab.dataset.faqTab === id;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
    panels.forEach(function (panel) {
      var isActive = panel.dataset.faqPanel === id;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
      if (!isActive) {
        panel.querySelectorAll('.fabpad-faq__item[open]').forEach(function (item) {
          item.removeAttribute('open');
        });
      }
    });
  }

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      activateTab(tab.dataset.faqTab);
      if (isMobileTabs() && typeof tab.scrollIntoView === 'function') {
        tab.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }
    });
  });

  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      scrollTabs(1);
    });
  }
  if (prevBtn) {
    prevBtn.addEventListener('click', function () {
      scrollTabs(-1);
    });
  }
  if (tabsRow) {
    tabsRow.addEventListener('scroll', updateTabArrows, { passive: true });
  }
  window.addEventListener('resize', updateTabArrows);
  updateTabArrows();
})();
